function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: "0"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M5 20V6h14v14H5zm2-2h7v-2H7v2zm10-4H7v-2h10v2zM7 10h10V8H7v2z",
  opacity: ".3",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fillOpacity: ".87"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.82 4H19c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H5c-.14 0-.27-.01-.4-.03a2.008 2.008 0 01-1.44-1.19c-.1-.24-.16-.51-.16-.78V6c0-.28.06-.53.16-.77s.25-.46.43-.64c.27-.27.62-.47 1.01-.55.13-.03.26-.04.4-.04h4.18C9.6 2.84 10.7 2 12 2s2.4.84 2.82 2zM7 10V8h10v2H7zm10 4v-2H7v2h10zm-3 2H7v2h7v-2zM12 3.75c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM5 20h14V6H5v14z",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fillOpacity: ".87"
}));